<template>
  <ApplicationWrapper :hideHeader="true" :showTwoActionLines="this.showTwoActionLines" @update:actionArea="handleActionAreaChanged">
    <template slot="details">
      <Detail class="text-center mt-4">
        <template slot="header">
          <!-- success messages for booking via PayPal or Klarna -->
          <v-list-item-title v-if="paymentOption == PAYMENTOPTION_PAYPAL || paymentOption == PAYMENTOPTION_KLARNA">
            <div
              v-if="type == TYPE_COURSES"
              v-html="$t('payment.successMessage', [$t('common.article_des'), $t('common.label_courses'), bookedTitle])" />

            <div v-if="type == TYPE_HALLS" v-html="$t('payment.successMessage', [$t('common.article_der'), $t('common.label_hall'), bookedTitle])" />
          </v-list-item-title>

          <!-- success messages for booking via invoice / club accounting -->
          <v-list-item-title v-else>
            <div
              v-if="type == TYPE_COURSES"
              v-html="$t('payment.successMessageClubAccounting', [$t('common.article_des'), $t('common.label_courses'), bookedTitle])" />

            <div
              v-if="type == TYPE_HALLS"
              v-html="$t('payment.successMessageClubAccounting', [$t('common.article_der'), $t('common.label_hall'), bookedTitle])" />
          </v-list-item-title>

          <br />

          <!-- price messages for booking via PayPal or Klarna -->
          <v-list-item-title v-if="paymentOption == PAYMENTOPTION_PAYPAL || paymentOption == PAYMENTOPTION_KLARNA">
            <div
              v-if="price > 0.0"
              v-html="
                $t('payment.successMessagePrice', [
                  $n(price, 'currency', 'de-DE'),
                  feeAmount > 0
                    ? $t('payment.successMessagePriceAddon', [$n(feeAmount, 'currency', 'de-DE'), $t('payment.' + paymentOption.toLowerCase())])
                    : '',
                  this.SessionData.club.name,
                ])
              " />
            <div v-else>
              <div v-if="type == TYPE_COURSES">
                {{ $t('payment.successMessagePriceFree', [$t('common.article_des'), $t('common.label_courses')]) }}
              </div>
              <div v-if="type == TYPE_HALLS">
                {{ $t('payment.successMessagePriceFree', [$t('common.article_der'), $t('common.label_hall')]) }}
              </div>
            </div>
          </v-list-item-title>

          <!-- price messages for booking via invoice / club accounting -->
          <v-list-item-title v-else>
            <div v-if="price > 0.0" v-html="$t('payment.successMessageClubAccountingPrice', [$n(price, 'currency', 'de-DE')])" />

            <div v-else>
              <div v-if="type == TYPE_COURSES">
                {{ $t('payment.successMessagePriceFree', [$t('common.article_des'), $t('common.label_courses')]) }}
              </div>
              <div v-if="type == TYPE_HALLS">
                {{ $t('payment.successMessagePriceFree', [$t('common.article_der'), $t('common.label_hall')]) }}
              </div>
            </div>
          </v-list-item-title>

          <!-- mailing information -->
          <v-list-item-subtitle>
            <v-icon class="mt-4" color="success" size="120"> mdi-check-circle-outline </v-icon>
            <v-spacer />
            {{ $t('payment.successSubMessage') }}
          </v-list-item-subtitle>
        </template>
      </Detail>
    </template>

    <template slot="actionbuttons">

      <v-row justify="space-around" align="center" no-gutters>
        <v-btn color="primary" @click="handleMyBookingsClick" :style="showTwoActionLines ? 'width: 95%' : ''" class="ma-2">{{ $t('overview.tab_label_myBookings') }}</v-btn>

        <v-btn v-if="!fromMyBookings" class="ma-2" color="primary" @click="handleGoToOverviewClick" :style="showTwoActionLines ? 'width: 95%' : ''">{{
          $t(type == TYPE_COURSES ? 'overview.details_header_backToCourseOverview' : 'overview.details_header_backToHallOverview')
        }}</v-btn>
      </v-row>
    </template>
  </ApplicationWrapper>
</template>

<script>
// vuex
import { mapGetters } from 'vuex';
import { GET_SESSIONDATA } from '@/store/storeMutator';

// mixins
import Constants from '@/mixins/constants.js';
import Helpers from '@/mixins/helpers.js';
import Booking from '@/mixins/booking.js';
import ResponsiveMixin from '@/mixins/responsive.js';


// components
import ApplicationWrapper from '@/components/controls/ApplicationWrapper.vue';
import Detail from '@/components/controls/Detail.vue';

export default {
  name: 'PaymentSuccess',

  emits: ['onButtonMyBookingsClick', 'onButtonOverviewClick'],

  mixins: [Constants, Helpers, Booking, ResponsiveMixin],

  components: {
    ApplicationWrapper,
    Detail,
  },

  props: {
    price: Number,
    feeAmount: Number,
    type: String,
    bookedTitle: String,
    paymentOption: String,
    /** whether the PaymentDialog got called from the "Meine Buchungen" area */
    fromMyBookings: Boolean,
  },

  data() {
    return  {
      showTwoActionLines: false
    }
  },

  methods: {
    handleActionAreaChanged(show) {
      this.showTwoActionLines = show;
    },

    handleMyBookingsClick() {
      this.$emit('onButtonMyBookingsClick');
    },

    handleGoToOverviewClick() {
      this.$emit('onButtonOverviewClick');
    },
  },

  computed: {
    ...mapGetters({ SessionData: GET_SESSIONDATA }),
  },
};
</script>

<style scoped>
.v-list-item__title > * {
  text-wrap: balance;
}
</style>
